export default __webpack_public_path__ + "static/media/nse-6228475226791087856-a3872f64-ae75-4f07-a3d6-6faffc412cdc.f40aa3d9.jpg";